var _path, _path2, _path3, _path4, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgZoomOut = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 5.5C7.5 6.60457 6.60457 7.5 5.5 7.5H1C0.447715 7.5 1.31135e-07 7.05228 1.31135e-07 6.5C1.31135e-07 5.94772 0.447715 5.5 1 5.5H5.5V1C5.5 0.447715 5.94772 0 6.5 0C7.05228 0 7.5 0.447715 7.5 1V5.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 7.5C14.3954 7.5 13.5 6.60457 13.5 5.5V1C13.5 0.447715 13.9477 1.9571e-08 14.5 4.37121e-08C15.0523 6.78533e-08 15.5 0.447715 15.5 1V5.5L20 5.5C20.5523 5.5 21 5.94772 21 6.5C21 7.05229 20.5523 7.5 20 7.5L15.5 7.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 15.5C13.5 14.3954 14.3954 13.5 15.5 13.5L20 13.5C20.5523 13.5 21 13.9477 21 14.5C21 15.0523 20.5523 15.5 20 15.5L15.5 15.5V20C15.5 20.5523 15.0523 21 14.5 21C13.9477 21 13.5 20.5523 13.5 20V15.5Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 13.5C6.60457 13.5 7.5 14.3954 7.5 15.5L7.5 20C7.5 20.5523 7.05228 21 6.5 21C5.94771 21 5.5 20.5523 5.5 20L5.5 15.5L1 15.5C0.447715 15.5 -7.24234e-08 15.0523 0 14.5C7.24234e-08 13.9477 0.447715 13.5 1 13.5L5.5 13.5Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 5.5,
    y: 5.5,
    width: 10,
    height: 10,
    rx: 1,
    fill: "#0C0B0B",
    fillOpacity: 0.6
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgZoomOut);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/zoomOut.51b7fbfe73a80e93d6078f2ad24f51ff.svg";